import $x from '../$x'
//import httpUtil from './httpUtil';

export default {
    eid: '',
    setUserInfo(loginInfo) {
        //url参数上的优先级最高
        Object.assign(this, loginInfo, loginInfo && loginInfo.configs)
    },
    save(name = '_user') {
        $x.storage.setObj(name, this)
    },
    load(name = '_user') {
        var saved = $x.storage.getObj(name)
        this.setUserInfo(saved)
    }
}

// function getUrlCfg() {
//     var cfg = {}
//     var titleBg = httpUtil.getQueryStr('titleBg');
//     var footerBg = httpUtil.getQueryStr('footerBg');
//
//     if (titleBg) cfg.titleBg = titleBg;
//     if (footerBg) cfg.footerBg = footerBg;
//     return cfg;
// }
